import React from 'react';
import {Button} from 'reactstrap';

const ShowMoreNotExactPackagesButton = (props) => {
  return (
    <Button color='link' type='button' className='show-more-not-exact-packages-button' onClick={() => props.onClick()}>
      <span className='button-text '>
        <span className='bold main-button-text d-block'>{props.mainText}</span>
        <span className='sub-button-text d-block'>{props.subText}</span>
      </span>
      {props.isOpen ? <span className='x-icon'>&#x2715;</span> : <span className='plus-icon'>&#43;</span>}
    </Button>
  );
};

export default ShowMoreNotExactPackagesButton;
